/**
 * Ory Identities API
 * This is the API specification for Ory Identities with features such as registration, login, recovery, account verification, profile settings, password reset, identity management, session management, email and sms delivery, and more. 
 *
 * The version of the OpenAPI document: 
 * Contact: office@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UiText } from './uiText';


/**
 * InputAttributes represents the attributes of an input node
 */
export interface UiNodeInputAttributes { 
    /**
     * The autocomplete attribute for the input. email InputAttributeAutocompleteEmail tel InputAttributeAutocompleteTel url InputAttributeAutocompleteUrl current-password InputAttributeAutocompleteCurrentPassword new-password InputAttributeAutocompleteNewPassword one-time-code InputAttributeAutocompleteOneTimeCode
     */
    autocomplete?: UiNodeInputAttributes.AutocompleteEnum;
    /**
     * Sets the input\'s disabled field to true or false.
     */
    disabled: boolean;
    label?: UiText;
    /**
     * The input\'s element name.
     */
    name: string;
    /**
     * NodeType represents this node\'s types. It is a mirror of `node.type` and is primarily used to allow compatibility with OpenAPI 3.0.  In this struct it technically always is \"input\". text Text input Input img Image a Anchor script Script
     */
    node_type: UiNodeInputAttributes.NodeTypeEnum;
    /**
     * OnClick may contain javascript which should be executed on click. This is primarily used for WebAuthn.
     */
    onclick?: string;
    /**
     * OnLoad may contain javascript which should be executed on load. This is primarily used for WebAuthn.
     */
    onload?: string;
    /**
     * The input\'s pattern.
     */
    pattern?: string;
    /**
     * Mark this input field as required.
     */
    required?: boolean;
    /**
     * The input\'s element type. text InputAttributeTypeText password InputAttributeTypePassword number InputAttributeTypeNumber checkbox InputAttributeTypeCheckbox hidden InputAttributeTypeHidden email InputAttributeTypeEmail tel InputAttributeTypeTel submit InputAttributeTypeSubmit button InputAttributeTypeButton datetime-local InputAttributeTypeDateTimeLocal date InputAttributeTypeDate url InputAttributeTypeURI
     */
    type: UiNodeInputAttributes.TypeEnum;
    /**
     * The input\'s value.
     */
    value?: any | null;
}
export namespace UiNodeInputAttributes {
    export type AutocompleteEnum = 'email' | 'tel' | 'url' | 'current-password' | 'new-password' | 'one-time-code';
    export const AutocompleteEnum = {
        Email: 'email' as AutocompleteEnum,
        Tel: 'tel' as AutocompleteEnum,
        Url: 'url' as AutocompleteEnum,
        CurrentPassword: 'current-password' as AutocompleteEnum,
        NewPassword: 'new-password' as AutocompleteEnum,
        OneTimeCode: 'one-time-code' as AutocompleteEnum
    };
    export type NodeTypeEnum = 'text' | 'input' | 'img' | 'a' | 'script';
    export const NodeTypeEnum = {
        Text: 'text' as NodeTypeEnum,
        Input: 'input' as NodeTypeEnum,
        Img: 'img' as NodeTypeEnum,
        A: 'a' as NodeTypeEnum,
        Script: 'script' as NodeTypeEnum
    };
    export type TypeEnum = 'text' | 'password' | 'number' | 'checkbox' | 'hidden' | 'email' | 'tel' | 'submit' | 'button' | 'datetime-local' | 'date' | 'url';
    export const TypeEnum = {
        Text: 'text' as TypeEnum,
        Password: 'password' as TypeEnum,
        Number: 'number' as TypeEnum,
        Checkbox: 'checkbox' as TypeEnum,
        Hidden: 'hidden' as TypeEnum,
        Email: 'email' as TypeEnum,
        Tel: 'tel' as TypeEnum,
        Submit: 'submit' as TypeEnum,
        Button: 'button' as TypeEnum,
        DatetimeLocal: 'datetime-local' as TypeEnum,
        Date: 'date' as TypeEnum,
        Url: 'url' as TypeEnum
    };
}


